import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import React, { useContext } from "react";
import { GlobalContext } from "../GlobalContext";
import { SignIn } from "../pages/common/SignIn";
import { SundayTool } from "../pages/web/SundayTool";

const WebPaths = () => {
	const { authenticated } = useContext(GlobalContext);

	return (
		<>
			<Router>
				<Routes>
					<Route
						path="/"
						element={authenticated ? <Navigate to={"/sunday-tool"} /> : <Navigate to={"/signin"} />}
						exact
					/>

					<Route path="/signin" element={authenticated ? <Navigate to={"/"} /> : <SignIn />} exact />

					<Route
						path="/sunday-tool"
						element={authenticated ? <SundayTool /> : <Navigate to="/signin" />}
						exact
					/>

					<Route path="*" element={<>404 page not found</>} />
				</Routes>
			</Router>
		</>
	);
};

export { WebPaths };
